export default {
    typeLookup(state) {
        return state.typeLookup
    },
    getActiveDashboardIdByType(state, getters) {
        return (type) => {
            var dashboardsForType = getters.typeLookup[type] || []
            var stub = dashboardsForType.first((v) => v.isActive) || dashboardsForType.first()
            return stub && stub.id
        }
    },
    getDashboardById(state, getters) {
        return (id) => {
            var dashboard = state.dashboards[id]
            if (!dashboard) {
                return null
            }
            var widgetIds = dashboard.widgetIds || []
            var widgets = widgetIds.map(getters.getWidgetById).nonNull()
            return {
                id: dashboard.id,
                name: dashboard.name,
                type: dashboard.type,
                widgets: widgets
            }
        }
    },
    getWidgetById(state) {
        return (id) => state.widgets[id]
    },
    dashboards(state) {
        return state.dashboards
    },
    currentDraggedWidget(state) {
        return state.currentDraggedWidget
    }
}
